import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../user/authentication.service';
import { REDIRECT_AFTER_LOGIN_PATH } from '../../app.component';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authService.hasAccessToken()) {
      localStorage.setItem(
        REDIRECT_AFTER_LOGIN_PATH,
        window.location.pathname + window.location.search
      );

      this.router.navigate(['sign-in']);
      return false;
    }

    return true;
  }
}
